import { __assign, __rest } from "tslib";
import * as React from 'react';
import { TranslationsProvider } from '../../i18next';
import { NamespacesConsumer } from 'react-i18next';
import { CounterHolidaySale, } from './counter-holiday-sale';
function CounterHolidaySaleExport(_a) {
    var locale = _a.locale, counterHolidaySaleProps = __rest(_a, ["locale"]);
    return (React.createElement(TranslationsProvider, { locale: locale },
        React.createElement(NamespacesConsumer, null, function (t) { return React.createElement(CounterHolidaySale, __assign({}, counterHolidaySaleProps, { t: t })); })));
}
export { CounterHolidaySaleExport };
//# sourceMappingURL=counter-holiday-sale-export.js.map